import { useTranslation } from 'react-i18next';
import restaurant from '@/assets/images/restaurant.png';
import Button from '@/components/SharedButton/Button';
import { KITOPI_APP_STORE_ADJUST_REDIRECT } from '@/constants/appStores';
import { BUTTON_SOURCES } from '@/constants/buttonSources';
import { useBrowserUserId } from '@/hooks/useBrowserUserId';
import { useGetCashbackPercentageValue } from '@/hooks/useGetCashbackPercentageValue';
import useValidateQueryParams from '@/hooks/useValidateQueryParams';
import { useBranding } from '@/utils/branding';
import { trackButtonClick } from '@/utils/gtmButtonClicked';
import styles from './NoBill.module.scss';

const NoBill = () => {
  const { t } = useTranslation();
  const browserUserId = useBrowserUserId();
  const { queryParams } = useValidateQueryParams();
  const { brandId, tableNumber, counterNumber } = queryParams();
  const cashbackPercentageValue = useGetCashbackPercentageValue();
  const { showAppLinks } = useBranding();

  const handleDownloadClick = () => {
    trackButtonClick({
      buttonId: 'download-app-no-bill',
      buttonName: t('noBill.downloadKitopiApp'),
      buttonSource: BUTTON_SOURCES.NO_BILL,
      onTracked: () => {
        window.open(KITOPI_APP_STORE_ADJUST_REDIRECT, '_blank');
      },
      urlParams: {
        brandId: brandId || undefined,
        orderId: undefined,
        tableNumber,
        counterNumber,
      },
      extraParams: {
        browser_user_id: browserUserId,
      },
    });
  };

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.imageWrapper}>
          <img src={restaurant} alt={t('noBill.restaurant')} className={styles.image} />
        </div>

        <h2 className={styles.title}>{t('noBill.looksLikeNoOrder')}</h2>
        <p className={styles.subheader}>{t('noBill.billWillAppear')}</p>
      </div>
      <div className={styles.footer}>
        {showAppLinks && (
          <>
            <p className={styles.ctaText}>
              {!!cashbackPercentageValue &&
                t('noBill.downloadAppCashback', { cashbackPercentageValue })}
            </p>
            <div className={styles.buttonWrapper}>
              <Button label={t('noBill.downloadKitopiApp')} onClick={handleDownloadClick} logo />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default NoBill;
